import styled, { css } from 'styled-components';

import { HoverUnderline } from '@app/pages/NFTDetailView/components/MainStage/components/NFTInfo/styles';

import { ReactComponent as VerifiedIcon } from './verified.svg';

export const Wrapper = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    overflow: hidden;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 13px;
    }
`;

export const Thumbnail = styled.div<{ $image?: string | null }>`
    width: 32px;
    height: 32px;
    border-radius: 100%;
    background-color: rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;

    position: relative;

    ${({ $image }) =>
        $image &&
        css`
            background-image: url(${$image});
        `}

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 40px;
        height: 40px;
    }
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    overflow: hidden;
    padding-top: 1px;
    flex-grow: 1;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 3px;
    }
`;

export const CollectionName = styled.div`
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.02em;
    color: #ffffff;
    text-transform: uppercase;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    position: relative;

    padding-bottom: 2px;

    a {
        position: relative;
    }

    ${HoverUnderline} {
        top: unset;
        bottom: 0;
    }

    &:hover {
        ${HoverUnderline} {
            transform: scaleX(1);
            transform-origin: 0 0;
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
    }
`;

export const AssetCount = styled.div`
    font-weight: 700;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 12px;
    }
`;

export const ThumbnailSkeleton = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 100%;
    background-color: rgba(255, 255, 255, 0.1);
    flex-shrink: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 40px;
        height: 40px;
    }
`;

export const VerifiedBadge = styled(VerifiedIcon)`
    position: absolute;
    right: -4px;
    top: -4px;
`;
